module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 7 15",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#facebook",
      toString: function () {
        return this.url;
      }
    }